import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { isEmpty } from "lodash";
// components
import RMDRComboBox from "@/components/RMDRComboBox";
import RMDRTextBox from "@/components/RMDRTextBox";
// type
import { TMainPageLayoutV3 } from "../type";
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";


type TRender = {
    languageVersions:TLanguageVersionList[],
    params:{
        searchPagePayload?:any;
        payloadListIsLoading?:boolean;
        [key:string]:any;
    }
}

type TVerboseResources = {
    formSearchString:string;
    formSearchPlaceholderString:string;
    filterOrderBy:string;
    filterItemsPerPage:string;
    filterOrderByTitle:string;
    filterItemsPerPageTitle:string;
}

const Render = ( props:TRender ) => {

    const [ searchParams, setSearchParams ] = useSearchParams();

    const [ verboseResources, setVerboseResources ] = useState<TVerboseResources>({
        formSearchString:"",formSearchPlaceholderString:"",filterOrderBy:"",filterItemsPerPage:"",filterOrderByTitle:"",filterItemsPerPageTitle:""
    });

    useEffect(
        () => {
            const formSearchString = metaDataLanguageVersion("formSearchString", props.languageVersions);
            const formSearchPlaceholderString = metaDataLanguageVersion("formSearchPlaceholderString", props.languageVersions);
            const filterOrderBy = metaDataLanguageVersion("filterOrderBy", props.languageVersions);
            const filterItemsPerPage = metaDataLanguageVersion("filterItemsPerPage", props.languageVersions);
            const filterOrderByTitle = metaDataLanguageVersion("filterOrderByTitle", props.languageVersions);
            const filterItemsPerPageTitle = metaDataLanguageVersion("filterItemsPerPageTitle", props.languageVersions);
            setVerboseResources({
                formSearchString,formSearchPlaceholderString,filterOrderBy,filterItemsPerPage,filterOrderByTitle,filterItemsPerPageTitle
            });
        }, [ props.languageVersions ]
    )

    const itemsPerPageOnClick = (name:string, data:any) => {
        if ( data ) {
            searchParams.set(name, data.value );
            searchParams.set("page", "1" );
            setSearchParams(searchParams, { replace:true });
        }
    }

    const orderByOnClick = (name:string, data:any) => {
        if ( data ) {
            searchParams.set(name, data.value );
            searchParams.set("page", "1" );
            setSearchParams(searchParams, { replace:true });
        }
    }

    const formOnSubmit = ( event:React.SyntheticEvent ) => { 
        event.preventDefault();
        const target = event.target as typeof event.target & {
            q: { value: string },
        };

        searchParams.set("q", target.q.value );
        searchParams.set("page", "1" );
        setSearchParams(searchParams, { replace:true });
    }

    return (
        <div className="filters">
            <div className="filter-content">
                <div className="filter-form-items">
                    <div className="row align-items-end g-2">
                        <form className="col col-12 col-md-12 col-lg-7" onSubmit={formOnSubmit}>
                            <RMDRTextBox
                                name={"q"}
                                value={props.params.searchPagePayload?.q}
                                title={verboseResources.formSearchString}
                                placeholder={verboseResources.formSearchPlaceholderString}
                                className="form-clt"
                            />
                        </form>
                        {
                            !isEmpty(verboseResources.filterItemsPerPage) && (
                                <RMDRComboBox
                                    name="top"
                                    title={verboseResources.filterItemsPerPageTitle}
                                    dataSource={JSON.parse(verboseResources.filterItemsPerPage)}
                                    value={props.params.searchPagePayload?.top}
                                    displayExpr="name"
                                    idExpr="value"
                                    searchExpr="name"
                                    className="form-clt col col-12 col-md-6 col-lg-2 md-p-0"
                                    onClick={itemsPerPageOnClick}
                                />
                            )
                        }
                        {
                            !isEmpty(verboseResources.filterOrderBy) && (
                                <RMDRComboBox
                                    name="sort"
                                    title={verboseResources.filterOrderByTitle}
                                    dataSource={JSON.parse(verboseResources.filterOrderBy)}
                                    value={props.params.searchPagePayload?.sort}
                                    displayExpr="name"
                                    idExpr="value"
                                    searchExpr="name"
                                    className="form-clt col col-12 col-md-6 col-lg-3"
                                    onClick={orderByOnClick}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
        
    )

}

const MNPG034 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG034.rendered: ", props);

    if ( !props.template?.languageVersions || isEmpty(props.template?.languageVersions) || !props.params || isEmpty(props.params) ) return null;

    return <Render languageVersions={props.template.languageVersions} params={props.params} />
}

const Component = React.memo(MNPG034, ( prevProps:TMainPageLayoutV3, nextProps:TMainPageLayoutV3 ) => {
    return !(
        prevProps.params?.searchPagePayload !== nextProps.params?.searchPagePayload 
        || prevProps.params?.pageListIsLoading !== nextProps.params?.pageListIsLoading
    )
});

export default Component;
